import { serviceRequest } from 'utils/http';
import { ReferralService, Visit601StatusDto } from 'common/api';
export function update601VisitStatusAPI(visit601StatusDto: Visit601StatusDto) {
  return serviceRequest(() =>
    ReferralService.referralControllerUpdate601VisitStatus(visit601StatusDto)
  );
}
